<template>
  <b-container class="main-content login-page">
    <form class="form-signin" @submit.prevent="handleSubmit">
      <h1 class="h3 mb-3 font-weight-normal">Anmeldung</h1>
      <p v-if="error" class="error-msg">Login fehlgeschlagen!</p>
      <label for="inputEmail" class="sr-only">E-Mail Adresse</label>
      <input v-model="username" type="email" id="inputEmail" class="form-control" placeholder="E-Mail Adresse" required autofocus>
      <label for="inputPassword" class="sr-only">Passwort</label>
      <input v-model="password" type="password" id="inputPassword" class="form-control" placeholder="Passwort" required>
      <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Angemeldet bleiben
        </label>
      </div>
      <b-button variant="primary" :disabled="loading" type="submit" block size="lg">
        Anmelden
        <b-spinner type="grow" v-if="loading"></b-spinner>
      </b-button>
    </form>
  </b-container>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      submitted: false,
      loading: false,
      error: false,
    };
  },
  methods: {
    handleSubmit(e) {
      this.loading = true;
      this.submitted = true;
      const { username, password } = this;
      if (username && password) {
        this.$store.dispatch('login', { username, password })
          .then(
            () => {
              this.loading = false;
              this.$router.push('/');
            },
            (error) => {
              this.loading = false;
              this.error = true;
              console.error(error);
            },
          );
      }
    },
  },
};
</script>

<style scoped>
  .spinner-grow {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: -1.6rem;
  }

  .error-msg{
    color: darkred;
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
  .form-signin .checkbox {
    font-weight: 400;
  }
  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

</style>
